<template>
  <div
    class="bbp-tabs-type2"
    :style="{gridTemplateColumns: `repeat(${tabs.length}, minmax(${minmax})`}"
  >
    <div
      v-for="tab in tabs"
      class="bbp-tabs-type2__item"
      :class="[activeTab === tab.id && 'bbp-tabs-type2__item_active']"
      :key="tab.id"
      @click="onClickTab(tab)"
    >
      {{tab.title}}
    </div>
  </div>
</template>

<script>
export default {
  name: 'BBPTabsType2',
  props: {
    tabs: {
      type: Array,
      default: () => ([])
    },
    minmax: {
      type: String,
      default: ''
    },
    activeTab: {
      type: Number,
      default: 1
    }
  },
  methods: {
    onClickTab ({ id }) {
      this.$emit('update:activeTab', id)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../sass/variables";

  .bbp-tabs-type2 {
    align-self: end;
    display: grid;
    grid-gap: 1px;
    align-items: center;
    margin-right: auto;

    &__item {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 58px;
      font-size: 14px;
      font-weight: 500;
      line-height: 17px;
      background: $color-alabaster;
      border-right: 1px solid $color-white;
      transition: 0.3s;
      cursor: pointer;

      &_active {
        background-color: $color-white;
        pointer-events: none;
      }

      &:hover {
        background-color: rgba($color-silver, 0.2);
      }

      &:first-child {
        border-radius: 5px 0 0 0;
      }

      &:last-child {
        border-radius: 0 5px 0 0;
        border-right: none;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Main/BBPTabsType2/BBPTabsType2.vue